import React from 'react';
import Navigation from '../navigation';
import ImageUploader from '../image-uploader';
import Card from './card';
import dayjs from 'dayjs'

export default class Contests extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            description: '',
            pageState: 'normal',
            featureImgUrl: '',
            uploadInProgress: false,
            expiration: '',
        };
    }

    componentDidMount() {
        if (!this.props.account.email) {
            this.props.getAccount();
        }
        if (this.props.contests === null) {
            this.props.getContests();
        }
    }

    handleSubmit() {
        const { title, description, expiration } = this.state;
        if (title !== '' && description !== '' && expiration !== '') {
            const data = {
                ...this.state,
                expiration: dayjs(this.state.expiration).format(),
            };
            this.props.createContest(data);
            this.setState({ pageState: 'normal' });
        }
    }

    updateFeatureImg(urls) {
        this.setState({ featureImgUrl: urls[0], uploadInProgress: false });
    }

    render() {
        const { contests, account } = this.props;
        const { pageState, uploadInProgress, featureImgUrl } = this.state;
        const yesterday = dayjs().subtract(1, 'day').format();
        return (
            <div>
                <Navigation {...this.props} />
                <div
                    className="px-8 py-12 relative"
                    style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage: `url(${require('../../assets/bg-1.jpg')})` }}>
                    <div className="bg-gradient-black-to-transparent"></div>
                    <div className="text-center">
                        <h2 className="relative text-center text-4xl lg:text-6xl text-white font-bold">Contests</h2>
                        {pageState === 'normal' && Boolean(account) && account.admin &&
                            <button
                                className="relative mt-8 font-bold p-4 bg-west-green hover:bg-west-green-400 hover:bg-west-green-400 items-center text-white leading-none rounded-full inline-flex"
                                onClick={() => this.setState({ pageState: 'new' })}>New contest</button>
                        }
                    </div>
                </div>
                <div className="min-h-screen bg-gray-200 p-4">
                    {pageState === 'normal' && Boolean(contests) &&
                        <div>
                            <h3 className="mt-8 px-4 text-gray-700">Current contests</h3>
                            <div className="w-full flex flex-wrap">
                                {contests.filter(item => dayjs(item.expires).isAfter(yesterday)).map(contest => (
                                    <Card
                                        expired={false}
                                        key={contest._id}
                                        contest={contest}
                                        {...this.props} />
                                ))}
                            </div>
                            {/* <h3 className="mt-8 px-4 text-gray-700">Expired contests</h3> */}
                            <div className="w-full flex flex-wrap">
                                {contests.filter(item => dayjs(item.expires).isBefore(dayjs(new Date()))).map(contest => (
                                    <Card
                                        expired={true}
                                        key={contest._id}
                                        contest={contest}
                                        {...this.props} />
                                ))}
                            </div>
                        </div>
                    }
                    {pageState === 'new' &&
                        <div className="max-w-3xl mx-auto">
                            <div className="max-w-xs mx-auto mb-8">
                                {Boolean(featureImgUrl) && featureImgUrl.length > 0 ?
                                    <div>
                                        {console.log("MMK", featureImgUrl)}
                                        <img src={featureImgUrl} alt=""/>
                                    </div>
                                    :
                                    <ImageUploader
                                        beginUpload={() => this.setState({ uploadInProgress: true })}
                                        updateFeatureImg={urls => this.updateFeatureImg(urls)} {...this.props} />
                                }
                            </div>
                            <label className="block font-semibold text-gray-700" htmlFor="title">Contest title</label>
                            <input
                                name="title"
                                className="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                type="text"
                                placeholder="Halloween costume contest"
                                onChange={e => this.setState({ title: e.target.value })}/>
                            <label className="mt-6 block font-semibold text-gray-700" htmlFor="expiration">Contest expiration date</label>
                            <input
                                name="expiration"
                                className="mt-2 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                type="date"
                                placeholder="Contest expiration date"
                                onChange={e => this.setState({ expiration: e.target.value })}/>
                            <label className="mt-6 block font-semibold text-gray-700" htmlFor="description">Contest description</label>
                            <textarea
                                className="mt-2 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                placeholder="Upload a photo of your Halloween costume"
                                rows="6"
                                onChange={e => this.setState({ description: e.target.value })}></textarea>
                            <button
                                className="p-4 text-gray-700 bg-transparent items-center text-white leading-none lg:rounded-full flex lg:inline-flex"
                                onClick={() => this.setState({ pageState: 'normal' })}>Cancel</button>
                            <button
                                disabled={uploadInProgress}
                                className={`mt-4 p-4 ${uploadInProgress ? 'bg-gray-600 cursor-not-allowed' : 'bg-west-green hover:bg-west-green-400'} items-center text-white leading-none lg:rounded-full flex lg:inline-flex`}
                                onClick={() => this.handleSubmit()}>{uploadInProgress ? 'Upload in progress..' : 'Create contest'}</button>
                        </div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/contests/index.js